module.exports = __webpack_public_path__ + "static/media/reading-list-back-image-dark.2b7f5869.png";